import { Configuration } from '@api/configuration';
import { useDependency } from '@app/shared';
import './admin.view.scss';
import { createSignal, Show } from 'solid-js';
import { SecurityService } from '@app/services/security.service';
import { LoadingIndicator } from '@app/components/loading-indicator/loading-indicator.component';

export function AdminView() {
	const configuration = useDependency<Configuration>(Configuration);
	const securityService = useDependency<SecurityService>(SecurityService);

	const [
		isPreparingDownload,
		setIsPreparingDownload
	] = createSignal(false);

	function startBrowserDownload(url: string) {
		const link = document.createElement('a');
		link.href = url;
		link.download = 'all-images.zip';
		document.body.appendChild(link);
		link.click();
		link.remove();
	}

	function downloadAllImages() {
		if (isPreparingDownload()) {
			return;
		}

		setIsPreparingDownload(true);

		const requestUrl = `${configuration.basePath}/media/downloadall?passcode=${securityService.getPasscode()}`;
		const xhr = new XMLHttpRequest();
		let headerHandled = false;
		let abortedAfterHeaders = false;

		xhr.onreadystatechange = () => {
			if (headerHandled || xhr.readyState < XMLHttpRequest.HEADERS_RECEIVED) {
				return;
			}

			headerHandled = true;
			abortedAfterHeaders = true;
			setIsPreparingDownload(false);

			// Stop the probe request and start a native browser download right away.
			xhr.abort();
			startBrowserDownload(requestUrl);
		};

		xhr.onerror = () => {
			setIsPreparingDownload(false);
		};

		xhr.onabort = () => {
			if (!abortedAfterHeaders) {
				setIsPreparingDownload(false);
			}
		};

		xhr.onloadend = () => {
			if (!headerHandled) {
				setIsPreparingDownload(false);
			}
		};

		xhr.open('GET', requestUrl, true);
		xhr.send();
	}

	return (
		<div class="ta-center home narrow">
			<div class="teaser glass">
				<img src="/assets/images/newlyweds.jpeg" />
			</div>

			<div class="content ">
				<h1>Willkommen im Adminbereich</h1>
				<p>
					Hier kannst du die Inhalte der Galerie auf einen Schlag herunterladen.
				</p>

				<button
					class={`primary${isPreparingDownload() ?
						' loading' :
						''}`}
					disabled={isPreparingDownload()}
					onClick={() => downloadAllImages()}>
					{isPreparingDownload() ?
						'Datei wird vorbereitet...' :
						'Herunterladen'}
				</button>
				<Show when={isPreparingDownload()}>
					<div class="mt-4">
						<LoadingIndicator />
						<div class="mt-4">
							Wenn die Datei zum herunterladen bereit ist, startet der Download automatisch.
							Bitte dieses Fenster nicht schließen!
						</div>
					</div>
				</Show>
			</div>

			<div class="copyright">
				<span>Erstellt von Marco Klein&nbsp;-&nbsp;</span>
				<a href="https://marcoklein.engineer/" target="_blank" rel="noopener noreferrer">
					marcoklein.engineer
				</a>
			</div>
		</div>
	);
}
